import React, {useEffect, useState} from 'react';
import {Prompt, useHistory} from 'react-router-dom';
import {
    Button,
    FormControlLabel,
    Grid,
    InputBase,
    InputLabel,
    makeStyles,
    MenuItem,
    Radio,
    RadioGroup,
    useMediaQuery,
} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import {setClient, setListOfPatients} from '@cabinet-packages/redux';
import {ConfirmDialog, CustomDialog, Loading, SwipeStyledButton} from '@cabinet-packages/components';
import {editPatientInfo} from "@cabinet-packages/api";
import Typography from "@material-ui/core/Typography";
import CloseIcon from '@material-ui/icons/Close';
import MuiPhoneNumber from "material-ui-phone-number";
import {getDateInputPattern, getDateRequestPattern} from "../utils/InputValuePatterns";
import {AdmitIcon} from '../assets/tabsIcons/icons';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import GoogleLogin from 'react-google-login';
import facebookInscription from '../assets/images/socialMedia/facebook-inscription.png'
import googleInscription from '../assets/images/socialMedia/google-inscription.png'
import TextField from "@material-ui/core/TextField";
import CancelIcon from "@material-ui/icons/Clear";
import {roleOptions} from "./CabinetAddNewPatient";
import moment from "moment";

const useStyles = makeStyles(theme =>({
  root: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    width: '100%',
    maxWidth: '900px',
    borderRadius: '20px',
    '@media(max-width: 900px)': {
      display: 'block'
    }
  },
  scrollWrapper: {
    position: 'relative',
    maxHeight: '100%',
    width: '100%',
    height: '100%',
  },
  bodyContainer: {
    maxHeight: '100%',
    padding: '10px',
    width: '100%'
  },
  avatarQRCodeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width:700px)': {
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '0 10px',
    },
  },
  QRCodeContainer: {
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    backgroundColor: theme.palette.primary[100],
    width: '160px',
    height: '160px',
    fontSize: '3rem',
    '@media (max-width:700px)': {
      marginBottom: '20px',
    },
  },
  genderGroup: {
    flexDirection: 'row',
  },
  actionContainer: {
    padding: '20px 10px',
    display: 'flex',
    justifyContent: 'end',
    columnGap: '20px'
  },
  birthdayContainer: {
    padding: '4px 0',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto 1fr',
    gridGap: '5px',
  },
  editBtnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width:700px)': {
      padding: '0px 8px'
    },
  },
  editProfileContainer: {
    display: 'flex',
    columnGap: '20px',
    alignItems: 'center',
    cursor: 'pointer'
  },
  noData: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'center',
  },
  mainActionButton: {
    width: '100%',
    maxWidth: '300px',
    margin: '8px',
    '@media (max-width:700px)': {
      margin: '8px auto'
    },
  },
  inputRoot: {
    padding: '10px',
    border: `1px solid #F7F8F9`,
    backgroundColor: '#F7F8F9'
  },
  editInput: {
    padding: '10px',
    border: `1px solid #e8e8e8`,
    backgroundColor: "white",
  },
  inputLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '12px',
    margin: '10px'
  },
  cancelEditButton: {
    fontSize:'1rem',
    color: theme.palette.colors.text,
  },
  extraInputsContainer: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr',
    columnGap: '20px'
  },
  headerLabel: {
    color: theme.palette.primary.dark
  },
  extraLabel: {
    color: theme.palette.primary.main
  },
  inputAdorned: {
    backgroundColor: '#F7F8F9'
  },
  editAdorned: {
    backgroundColor: "white !important",
  },
  buttonContainer: {
    marginTop: '10px',
    height: '50px'
  },
  connectContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media(max-width: 900px)': {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
  },
  socialsButton: {
    width: '10rem',
    height: '3rem',
    border: 'none',
    borderRadius: '2rem',
    backgroundSize: '60%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
  },
  socialsContainer: {
    display: 'flex',
    columnGap: '10px'
  },
  optionContainer: {
    fontSize: '15px',
    height: '60px',
    color: 'black',
    fontWeight: '500 !important',
    '&.Mui-disabled': {
      fontSize: '15px',
      color: 'white',
      backgroundColor: 'rgba(6,86,79,0.67)',
      position: 'relative'
    },
  },
  radioContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr'
  },
  radioCheckedLabel: {
    fontSize: '15px'
  },
  radioUncheckedLabel: {
    fontSize: '15px',
    color: theme.palette.grey.text
  }
}));

function CabinetPatientCard() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))
  const { listOfPatients } = useSelector(state => state.patients);
  const {themeMaterialUI} = useSelector(store => store.theme);
  const idFromPathname = +history.location.pathname.split('/').pop();
  const foundPatient = listOfPatients && typeof listOfPatients !== 'string' && listOfPatients.find(currPatient => (+currPatient.id === idFromPathname));
  const [isChangedState, setIsChangedState] = useState(false);
  const [state, setState] = useState(null);
  const [i, setIsEditing] = useState(false);
  const isEditing = false
  const handleEditing = (e) => {
    // e.persist();
    // CustomDialog(TextAlertDialog, {
    //   text: 'На жаль, редагування даних пацієнта тимчасово недоступне. ' +
    //       'Якщо Вам потрібно замовити дослідження для іншої особи - додайте нового пацієнта, ' +
    //       'або зверніться на гарячу лінію.'
    // }, e, themeMaterialUI);

    setIsEditing(value => !value)
  };

  const updateState = (field, value) => {
    if (!isChangedState) setIsChangedState(true);
    setState(prev => ({
          ...prev,
          [field]: value,
        }
    ));
  };

  const handleCancel = (event) => {
    if (event) event.preventDefault();
    if (isChangedState) {
      CustomDialog(ConfirmDialog, {
        text: 'Відмінити редагування?',
        onConfirm: () => {
          setIsChangedState(false);
          setState(foundPatient);
          setIsEditing(false);
        },
      }, event, themeMaterialUI);
    } else {
      setIsEditing(false);
    }
  };

  const handleConfirm = (event) => {
    CustomDialog(ConfirmDialog, {
      text: 'Зберегти дані?',
      onConfirm: async () => {
        setIsChangedState(false);
        const {lastname, firstname, fathername, birthday, sex, id} = state;
        const birthdayDate = typeof birthday === 'string'
            ? birthday
            : new Date(birthday.toString()).toLocaleDateString().split('.').reverse().join('-');
        await editPatientInfo(lastname, firstname, fathername, birthdayDate, sex, id);
        dispatch(setClient({...state, birthday: birthdayDate}));
        dispatch(setListOfPatients(true));
        setIsEditing(false);
        // history.push('/account-settings');
      },
      onCancel: () => {
        setIsChangedState(false)
        setIsEditing(false)
      },
    }, event, themeMaterialUI);
  };

  useEffect(() => {
    if (!listOfPatients) dispatch(setListOfPatients());

    if (foundPatient) {
      setIsChangedState(false)
      setIsEditing(false)
      setState({...foundPatient, dt: foundPatient.birthday, role: foundPatient.main ? 'owner' : 'null', customRole: ''});
    }

  },[dispatch, listOfPatients, foundPatient]);

  return (!listOfPatients
      ? <div className={classes.noData}><Loading/></div>
      : !foundPatient
          ? <div className={classes.noData}>Дані не доступні</div>
          : <div className={classes.root}>
              {/*<div className={classes.editBtnContainer}>*/}
              {/*  {state && (*/}
              {/*    <div>*/}
              {/*      <Typography color={"textPrimary"} variant={'h4'} className={classes.headerLabel}>*/}
              {/*        Вітаємо, {foundPatient.firstname}*/}
              {/*      </Typography>*/}
              {/*      <Typography className={classes.extraLabel}>*/}
              {/*        {state.main ? "Ви увійшли в особистий кабінет" : "Ви увійшли у доданий Вами кабінет пацієнта"}*/}
              {/*      </Typography>*/}
              {/*    </div>*/}
              {/*  )}*/}
              {/*  <div className={classes.editProfileContainer} onClick={handleEditing}>*/}
              {/*    {isEditing ?*/}
              {/*        <CloseIcon style={{fontSize: '12px', color: 'green'}}/> :*/}
              {/*        <EditIcon style={{fontSize: '12px', color: 'red'}}/>*/}
              {/*    }*/}
              {/*    {mdUp && (*/}
              {/*        <Typography style={{width: '50px', color: 'grey', fontSize: '0.7rem'}}>*/}
              {/*          {isEditing ? "Скасувати редагування" : "Редагувати профіль"}*/}
              {/*        </Typography>*/}
              {/*    )}*/}
              {/*  </div>*/}
              {/*</div>*/}
              {state &&
                <Grid container direction={'row'} className={classes.bodyContainer} spacing={1}>
                  <Grid item xs={12}>
                    <InputLabel className={classes.inputLabel}>Прізвище</InputLabel>
                    <InputBase
                        variant="standard"
                        value={state.lastname}
                        onChange={(event) => updateState('lastname', event.target.value)}
                        fullWidth
                        inputProps={{
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel className={classes.inputLabel}>Ім'я</InputLabel>
                    <InputBase
                        variant="standard"
                        value={state.firstname}
                        onChange={(event) => updateState('firstname', event.target.value)}
                        fullWidth
                        inputProps={{
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel className={classes.inputLabel}>По-батькові</InputLabel>
                    <InputBase
                        variant="standard"
                        value={state.fathername}
                        onChange={(event) => updateState('fathername', event.target.value)}
                        fullWidth
                        inputProps={{
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  <Grid item xs={mdUp ? 6 : 12}>
                    <InputLabel className={classes.inputLabel}>Контактний телефон</InputLabel>
                    <MuiPhoneNumber
                        defaultCountry='ua'
                        countryCodeEditable={false}
                        fullWidth={true}
                        value={state.phone}
                        onChange={(phone) => updateState('phone', phone)}
                        disableDropdown={true}
                        InputProps={{
                          disableUnderline: true,
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot,
                          style: {height: '40px'}
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  <Grid item xs={mdUp ? 3 : 6}>
                    <InputLabel className={classes.inputLabel}>Дата народження</InputLabel>
                    <InputBase
                        variant="standard"
                        value={moment(state.birthday).format('DD / MM / YYYY')}
                        onChange={(event) => {
                          console.log(getDateRequestPattern(event.target.value))
                          updateState('birthday', getDateRequestPattern(event.target.value))
                        }}
                        inputProps={{
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  <Grid item xs={mdUp ? 3 : 6}>
                    <InputLabel className={classes.inputLabel}>Стать</InputLabel>
                    <RadioGroup
                        className={classes.radioContainer}
                        value={state.sex}
                        onChange={(event) => updateState('sex', event.target.value)}
                      >
                      <FormControlLabel classes={{label: state.sex === 'F' ? classes.radioCheckedLabel : classes.radioUncheckedLabel}}
                                        value="F"
                                        control={<Radio size={"small"} checkedIcon={<AdmitIcon size={20}/>}/>}
                                        label="Ж"
                                        labelPlacement="start"
                                        disabled={!isEditing}/>
                      <FormControlLabel classes={{label: state.sex === 'M' ? classes.radioCheckedLabel : classes.radioUncheckedLabel}}
                                        value="M"
                                        control={<Radio size={"small"} checkedIcon={<AdmitIcon size={20}/>}/>}
                                        label="Ч"
                                        labelPlacement="start"
                                        disabled={!isEditing}/>
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel className={classes.inputLabel}>Електронна пошта</InputLabel>
                    <InputBase
                        variant="standard"
                        value={state.email}
                        onChange={(event) => updateState('email', event.target.value)}
                        fullWidth
                        inputProps={{
                          readOnly: !isEditing,
                          className: isEditing ? classes.editInput : classes.inputRoot
                        }}
                        onClick={() => setIsEditing(true)}
                    />
                  </Grid>
                  {isEditing && !state.main ? (
                    <>
                      <Grid item xs={6}>
                        <InputLabel className={classes.inputLabel}>Оберіть роль пацієнта</InputLabel>
                        <TextField
                            variant="standard"
                            value={state.role}
                            onChange={(event) => {
                              updateState('customRole', '')
                              updateState('role', event.target.value)
                            }}
                            fullWidth
                            className={classes.inputRoot}
                            InputProps={{ disableUnderline: true }}
                            select
                        >
                          <MenuItem classes={{root: classes.optionContainer}} disabled>
                            РОЛЬ ПАЦІЄНТА
                            <CancelIcon style={{position: 'absolute', right: 10, fontSize: '20px'}}/>
                          </MenuItem>
                          {roleOptions.map((item) => (
                              <MenuItem classes={{root: classes.optionContainer}} value={item.value}>{item.label}</MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel className={classes.inputLabel}>Або введіть роль вручну</InputLabel>
                        <InputBase
                            variant="standard"
                            placeholder={"Напишіть ким для Вас є цей пацієнт"}
                            value={state.customRole}
                            onChange={(event) => {
                              updateState('role', 'null')
                              updateState('customRole', event.target.value)
                            }}
                            fullWidth
                            className={classes.inputRoot}
                            InputProps={{
                              classes: { input: classes.inputRoot}
                            }}
                        />
                      </Grid>
                    </>
                    ) : (
                      <Grid item xs={12}>
                          <InputLabel className={classes.inputLabel}>Роль</InputLabel>
                          <InputBase
                              variant="standard"
                              value={state.main ? "Це є Ваш особистий кабінет" : "Дідусь"}
                              onChange={(event) => updateState('patient_role', event.target.value)}
                              fullWidth
                              inputProps={{
                                readOnly: true,
                                className: classes.inputRoot,
                              }}
                              onClick={() => setIsEditing(true)}
                              endAdornment={
                                <div style={{margin: '5px'}}>
                                  <AdmitIcon style={{fontSize: '20px', color: 'green', margin: '5px'}}/>
                                </div>
                              }
                              classes={{adornedEnd: classes.inputAdorned}}
                          />
                      </Grid>
                    )}
                </Grid>
                }
              <div className={classes.buttonContainer}>
                {isEditing ? (
                  <div className={classes.actionContainer}>
                    <Button className={classes.cancelEditButton} onClick={(event) => handleCancel(event)}>
                      {isChangedState ? 'СКАСУВАТИ' : 'ПОВЕРНУТИСЯ'}
                    </Button>
                    <SwipeStyledButton
                        animationStart={'left'}
                        animationMaterialColor={'#00B3A1'}
                        buttonMaterialColor={'#FFC101'}
                        hoverTextColor={'#ffffff'}
                        className={classes.cookieButton}
                        onClick={(event) => handleConfirm(event)}
                        disabled={!isChangedState
                            || state.lastname.length === 0
                            || state.firstname.length === 0
                            || !state.birthday
                            || !(state.birthday && (state.birthday.length === 10
                            || !isNaN(state.birthday.valueOf())))
                            || (state.customRole === '' && state.role === 'null')
                        }
                    >
                      ЗБЕРЕГТИ
                    </SwipeStyledButton>
                  </div>
                ) : (
                    <div className={classes.connectContainer}>
                      {/*<div>*/}
                      {/*  <Typography className={classes.extraLabel}>*/}
                      {/*    Зв'язок з аккаунтами*/}
                      {/*  </Typography>*/}
                      {/*  <Typography style={{fontWeight: 400}}>*/}
                      {/*    Ви можете пов'язати особистий кабінет "Медіс" зі своїми аккаунтами*/}
                      {/*  </Typography>*/}
                      {/*</div>*/}
                      {/*<div className={classes.socialsContainer}>*/}
                      {/*  <FacebookLogin*/}
                      {/*      appId="1088597931155576"*/}
                      {/*      //callback={responseFacebook}*/}
                      {/*      render={renderProps => (*/}
                      {/*          <button*/}
                      {/*              onClick={renderProps.onClick}*/}
                      {/*              className={classes.socialsButton}*/}
                      {/*              style={{*/}
                      {/*                backgroundImage: `url(${facebookInscription}`,*/}
                      {/*                backgroundColor: 'white',*/}
                      {/*                border: '2px solid #4967a9'*/}
                      {/*              }}/>*/}
                      {/*      )}*/}
                      {/*  />*/}
                      {/*  <GoogleLogin*/}
                      {/*      clientId="658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"*/}
                      {/*      // onSuccess={responseGoogle}*/}
                      {/*      // onFailure={responseGoogle}*/}
                      {/*      cookiePolicy={'single_host_origin'}*/}
                      {/*      render={renderProps => (*/}
                      {/*          <button onClick={renderProps.onClick}*/}
                      {/*                  className={classes.socialsButton}*/}
                      {/*                  style={{*/}
                      {/*                    backgroundImage: `url(${googleInscription}`,*/}
                      {/*                    backgroundColor: 'white',*/}
                      {/*                    border: '2px solid #4285f4'*/}
                      {/*          }}/>*/}
                      {/*      )}*/}
                      {/*  />*/}
                      {/*</div>*/}
                    </div>
                )}
              </div>
          <Prompt when={isChangedState} message={() => "Заврешити редагування без збереження?"}/>
      </div>);
}

export default CabinetPatientCard;
